export default class PostNav {
  constructor() {
    if (!this.setVars()) return;

    this.setEvents();
  }

  setVars() {
    this.navContainer = document.querySelector('.postNav');
    if (!this.navContainer) return;

    this.navElements = this.navContainer.querySelectorAll('li');
    if (!this.navElements.length) return;

    this.postContent = document.querySelector('.postContent');
    if (!this.navContainer) return;

    this.headings = this.postContent.querySelectorAll('h2, h3');

    this.currentNav = 0;

    return true;
  }

  setEvents() {
    this.navElements.forEach((singleNav) => {
      singleNav.addEventListener('click', this.jumpTo.bind(this));
    });
  }

  jumpTo(event) {
    const target = event.currentTarget;
    this.navElements[this.currentNav].classList.remove('active');
    target.classList.add('active');
    this.currentNav = target.dataset.element;
    this.headings[this.currentNav].scrollIntoView();
  }
}
